/* constants */
/// <reference path="../../typings/envconstants.d.ts" />
///<reference path="../../typings/envversions.d.ts" />
//import * as config from "./config/envconstants"
//import * as version from "./config/envversions"
/* core */
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
/* additional */
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { rootReducerMap } from "./store/root";
import { resetMetaReducer } from "./store/reset-meta";
import { ToastrModule } from "ngx-toastr";
/* routes */
import { routing, appRoutingProviders } from "./app.routes";
/* declared components */
import { AdminComponent } from "./admin/admin.component";
import { AgentComponent } from "./agent/agent.component";
import { ProductPickerComponent } from "./product-picker/product-picker.component";
import { PickerSectionComponent } from "./product-picker/picker-section.component";
import { PickerIconComponent } from "./product-picker/picker-icon.component";
import { PickerSelectionSectionComponent } from "./product-picker/picker-selection-section.component";
import { AnalysisComponent } from "./analysis/analysis.component";
import { DecisionComponent } from "./analysis/decision.component";
import { DemandComponent } from "./analysis/demand.component";
import { RecommendationComponent } from "./analysis/recommendation.component";
import { AttendantComponent } from "./attendant/attendant.component";
import { InfoComponent } from "./components/info.component";
import { RequestComponent } from "./components/request.component";
import { SnippetsComponent } from "./components/snippets.component";
import { MainMenuComponent } from "./components/main-menu.component";
import {
    SelectorStripComponent,
    SelectorComponent,
} from "./components/zbd-selector-strip.component";
import { Tab, TabBar } from "./components/tabbar.component";
import { ToggleableComponent } from "./components/toggleable.component";
import { SimpleToggleableComponent } from "./components/simpleToggleable.component";
import { CustomerComponent } from "./customer/customer.component";
import { OccasionComponent } from "./occasion/occasion.component";
import { ProductOccasionComponent } from "./occasion/product/product-occasion.component";
import { EventOccasionComponent } from "./occasion/event/event-occasion.component";
import { GlobalOccasionComponent } from "./occasion/global/global-occasion.component";
import { GlobalOccasionSectionListComponent } from "./occasion/global/global-occasion-section-list.component";
import { GlobalOccasionSectionComponent } from "./occasion/global/global-occasion-section.component";
import { SignAllModal } from "./components/modals/sign-all-modal.component";
import { SignModal } from "./components/modals/sign-modal.component";
import { QRCodeModal } from "./components/modals/qr-code-modal.component";
import { EmailFormModal } from "./components/modals/email-form-modal.component";
import { PcmModal } from "./components/modals/pcm-modal.component";
import { FinalizingModal } from "./components/modals/finalizing-modal.component";
import { Esignature } from "./print/esign/esignature.component";
import { PdfRendererComponent } from "./print/pdf/pdf-renderer.component";
import { PdfViewerComponent } from "./print/pdf/pdf-viewer.component";
import { ZBDAppComponent } from "./app.component";
import { ShellComponent } from "./shell.component";
import { TrackingTextComponent } from "./analysis/tracking-text.component";
import { SearchComponent } from "./search/search.component";
import { SearchFormComponent } from "./search/search-form.component";
import { SearchResultsComponent } from "./search/search-results.component";
import { AttachmentsComponent } from "./analysis/attachments.component";
import { ZbdInputComponent } from "./components/zbd-input.component";
import { ZbdListComponent } from "./components/zbd-list.component";
import { ZbdValidityIndicatorComponent } from "./components/zbd-validity-indicator.component";
import { ConfirmModalComponent } from "./components/modals/confirm-modal.component";
import { PromptModalComponent } from "./components/modals/prompt-modal.component";
import { EsignWidgetComponent } from "./print/esign/esignwidget.component";
import { DocumentEffects } from "./store/document/effects";
import { ZipDownloadComponent } from "./components/modals/zip-download.component";

/* declared providers */
import { ConsultationService } from "./services/consultation.service";
import { EsignService } from "./print/esign/esign.service";
import { SignpadService } from "./print/esign/signpad.service";
import { PersistenceService } from "./store/model/persistence.service";
import { UpdateCache } from "./store/model/update-cache.service";
import { ValidationService } from "./services/validation.service";
import { ProductIndexService } from "./services/product-index.service";
import { SanitizerService } from "./services/sanitizer.service";
import {
    NotificationService,
    GeneralToastOptions,
} from "./services/notification.service";
import { KeycloakService } from "./security";
import { ZipDownloadService } from "./services/zip-download.service";
import { VersionComponent } from "./components/version.component";
import { authInterceptorFn } from "./security";

const ZBD_COMPONENTS = [
    VersionComponent,
    AdminComponent,
    AgentComponent,
    ProductPickerComponent,
    PickerSectionComponent,
    PickerIconComponent,
    PickerSelectionSectionComponent,
    AnalysisComponent,
    DecisionComponent,
    DemandComponent,
    RecommendationComponent,
    AttendantComponent,
    InfoComponent,
    RequestComponent,
    SnippetsComponent,
    MainMenuComponent,
    SelectorStripComponent,
    SelectorComponent,
    Tab,
    TabBar,
    ToggleableComponent,
    SimpleToggleableComponent,
    CustomerComponent,
    OccasionComponent,
    ProductOccasionComponent,
    EventOccasionComponent,
    GlobalOccasionComponent,
    GlobalOccasionSectionListComponent,
    GlobalOccasionSectionComponent,
    SignAllModal,
    SignModal,
    QRCodeModal,
    PcmModal,
    EmailFormModal,
    FinalizingModal,
    Esignature,
    PdfRendererComponent,
    PdfViewerComponent,
    ZBDAppComponent,
    ShellComponent,
    TrackingTextComponent,
    SearchComponent,
    SearchFormComponent,
    SearchResultsComponent,
    AttachmentsComponent,
    ZbdInputComponent,
    ZbdListComponent,
    ZbdValidityIndicatorComponent,
    ConfirmModalComponent,
    PromptModalComponent,
    EsignWidgetComponent,
    ZipDownloadComponent,
];

const ZBD_PROVIDERS = [
    ConsultationService,
    EsignService,
    PersistenceService,
    UpdateCache,
    ValidationService,
    ProductIndexService,
    SanitizerService,
    NotificationService,
    GeneralToastOptions,
    SignpadService,
    KeycloakService,
    ZipDownloadService,
];

const IMPORTS = [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    routing,
    BrowserAnimationsModule,
    StoreModule.forRoot(rootReducerMap, {
        metaReducers: [resetMetaReducer],
        runtimeChecks: {
            strictStateImmutability: false,
            strictActionImmutability: false,
        },
    }),
    EffectsModule.forRoot([DocumentEffects]),
    StoreDevtoolsModule.instrument({
        maxAge: 10,
        connectInZone: true,
    }),
    ToastrModule.forRoot(),
];

@NgModule({
    imports: [...IMPORTS],
    declarations: [...ZBD_COMPONENTS],
    providers: [
        provideHttpClient(withInterceptors([authInterceptorFn])),
        { provide: GeneralToastOptions, useClass: GeneralToastOptions },
        appRoutingProviders,
        ...ZBD_PROVIDERS,
    ],
    bootstrap: [ShellComponent],
})
export class AppModule {}

/*@NgModule({
    imports: [ BrowserModule ],
    declarations: [VersionComponent],
    bootstrap: [VersionComponent]
})
export class VersionModule { }*/
